import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import api from '../../utils/intercepter/axiosConfig';
import { useNavigate } from 'react-router-dom';


const QuittanceTrEnregistrement = ({id_quittance_tr_enregistrement, w_id}) => {

            const navigate = useNavigate();
    
            // const {id_quittance_tr_enregistrement,w_id} = useParams();

            //quittance Info
            const [montant, setMontant] = useState(null);
            const [num_qte, setNumQuittance] = useState(null);
            const [date_qte, setDateQuittance] = useState(null);

    
            const getInfoQuittanceTrEnregistrement = async () => {
            try {
                const response = await api.post("/auth/getInfoQuittance", {
                w_id: Number(w_id),
                etat_liquidation_id: Number(id_quittance_tr_enregistrement)
                });

                if (response.data.status) {
                    console.log(response.data.response);
                   setMontant(response.data.response.montant);
                   setNumQuittance(response.data.response.num_qte);
                   setDateQuittance(response.data.response.date_qte);
                } else {
                console.error("Erreur API :", response.data.message);
                }
            } catch (err) {
                console.error("Erreur requête :", err);
            }
            };

    
    useEffect(() => {
        // console.log(id_quittance_tr_conservation)
        // console.log(w_id)
        // console.log(etat_liquidation_id_tr_conservation)
        if(id_quittance_tr_enregistrement && w_id){
            getInfoQuittanceTrEnregistrement();
        }
    },[id_quittance_tr_enregistrement, w_id])


        const retour = () => {
        navigate(-1);
    }

  return (
    <>

        <div>
        <span className='text-start'><strong>Information de quittance</strong></span>
                           <table className='table table-bordered table-striped'>
                                <tbody>
                                        <tr>
                                            <td className='text-start'>Montant</td>

                                            <td>{montant !== null ?  montant.toLocaleString('fr-FR', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 0,
                                                }) : '' } MRU
                                                </td>

                                        </tr>
                                        <tr>
                                            <td className='text-start'>Numéro</td>
                                            <td>{num_qte !== null ? num_qte.toLocaleString() : ''}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-start'>Date de création</td>
                                            <td>{date_qte || ''}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-start'>Opérations</td>
                                            <td>
                                            <button className='btn btn-success btn-sm'>Recevoir</button>
                                            </td>
                                        </tr>
                                        </tbody>
                              </table>
    </div>
    
    </>
  )
}

export default QuittanceTrEnregistrement
